import {GraphNode} from "#graph/nodes/graph/node"
import {registerNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import {GetPropertyDefinition} from "#graph/nodes/get-property/definition"
import type {GetPropertyDefinitionType} from "#graph/nodes/get-property/types"
import type {GraphNodeReturning} from "#graph/nodes/graph/validation"

@registerNode
export class GetProperty<Returns, Context> extends GraphNode<GetPropertyDefinitionType<Returns, Context>, Context> {
    static nodeClass = "GetProperty"
    static definition = GetPropertyDefinition

    override run = async (evaluator: Evaluator<Context>): Promise<Returns> => {
        const key = this.parameters.key
        const value = await evaluator.get(this.parameters.value as GraphNodeReturning<{[key in typeof key]: Returns}>)
        const parsedValue = this.definition.validation.returns.safeParse(value?.[key])
        if (!parsedValue.success) {
            throw new Error(`Failed to parse value: ${parsedValue.error.message}`)
        }
        return parsedValue.data
    }

    override runSync = (evaluator: Evaluator<Context>): Returns => {
        const key = this.parameters.key
        const value = evaluator.getSync(this.parameters.value as GraphNodeReturning<{[key in typeof key]: Returns}>)
        return value[key]
    }
}
